import { Input } from "@/components/ui/input";
import { FieldError } from "../field-error";
import { FieldLabel } from "../field-label";

interface CompanyNameFieldProps {
	value: string;
	onChange: (value: string) => void;
	error?: string;
}

export function CompanyNameField({
	value,
	onChange,
	error,
}: CompanyNameFieldProps) {
	return (
		<div className="onboarding-field">
			<FieldLabel>Nome da construtora</FieldLabel>
			<Input
				placeholder="Ex.: Aurora Construções"
				value={value}
				aria-invalid={!!error}
				onChange={(event) => onChange(event.target.value)}
			/>
			<FieldError message={error} />
			<p className="onboarding-hint">
				É assim que sua empresa aparece na plataforma.
			</p>
		</div>
	);
}
